import {ModuleRoleCode} from './Role';

export type ModuleType = {
  moduleId: number;
  moduleName: string;
  settings: ModuleSettings;
};

export type ModuleSettings = {
  isPubliclyListed: boolean;
  generalLeaderboardVisibility: ModuleGeneralLeaderboardVisibility;
  pictureUUID: string | null;
};

export enum ModuleGeneralLeaderboardVisibility {
  REALNAME = 'realname',
  NICKNAME = 'nickname',
  ANONYMOUS = 'anonymous',
}

export type ModuleData = Omit<ModuleType, 'moduleId'>;

export type ModuleEntry = {
  moduleId: number;
  moduleName: string;
  role: ModuleRoleCode;
  status: 'active' | 'archived' | 'pending';
  settings: ModuleMemberSettings;
};

export type ModuleMemberSettings = {
  activeGroups?: number[];
  appearInLeaderboard?: boolean;
};
